import { render, staticRenderFns } from "./Feriados.vue?vue&type=template&id=27ee8942&scoped=true"
import script from "./Feriados.vue?vue&type=script&lang=js"
export * from "./Feriados.vue?vue&type=script&lang=js"
import style0 from "./Feriados.vue?vue&type=style&index=0&id=27ee8942&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27ee8942",
  null
  
)

export default component.exports